import * as React from 'react';
import { useNavigate } from 'react-router';
import { ArrowLeft } from 'lucide-react';

interface DetailPageHeaderProps {
  /** Content for the left side (title, badge, etc.) */
  left: React.ReactNode;
  /** Optional content for the middle section */
  middle?: React.ReactNode;
  /** Optional content for the right side (actions) */
  right?: React.ReactNode;
  /** Optional back navigation */
  backTo?: {
    path: string;
    label: string;
  };
}

export function DetailPageHeader({ left, middle, right, backTo }: DetailPageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-4">
      {backTo && (
        <button
          onClick={() => navigate(backTo.path)}
          className="flex items-center text-sm text-muted-foreground hover:text-secondary mb-3 cursor-pointer"
        >
          <ArrowLeft className="mr-1 h-4 w-4" />
          {backTo.label}
        </button>
      )}

      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-3">
          {left}
        </div>

        {middle && (
          <div className="flex-1">
            {middle}
          </div>
        )}

        {right && (
          <div className="flex gap-2">
            {right}
          </div>
        )}
      </div>
    </div>
  );
}
